<template>
  <div class="vh-100 d-flex justify-content-center">
    <div class="form-access my-auto">
      <LoadingOverlay :show="loading" />
      <form @submit.prevent="submit">
        <span>Create Account</span>
        <div class="form-group">
          <input
            type="email"
            class="form-control"
            placeholder="Email Address"
            required
            v-model="form.email"
          />
        </div>
        <div class="form-group">
          <input
            type="password"
            class="form-control"
            placeholder="Password"
            required
            v-model="form.password"
          />
        </div>
        <div class="form-group">
          <input
            type="password"
            class="form-control"
            placeholder="Confirm Password"
            required
            v-model="form.confirmPassword"
          />
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            placeholder="Invitation code"
            required
            v-model="form.sid"
          />
        </div>
        <div class="form-group">
          <label class="form-label">Upload Passport/ID Front</label>
          <ImageUploader v-model="form.file1" />
        </div>
        <div class="form-group">
          <label class="form-label">Upload Passport/ID Back</label>
          <ImageUploader v-model="form.file2" />
        </div>
        <button type="submit" class="btn btn-primary">Create Account</button>
      </form>
      <h2>
        Already have an account?
        <router-link to="/login"> Sign in here</router-link>
      </h2>
    </div>
  </div>
</template>

<script>
import { signup } from "@/apis/user";
import { uploadImg } from "@/apis/wallet";
import { message } from "@/utils/message";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import ImageUploader from "@/components/ImageUploader.vue";
export default {
  components: {
    LoadingOverlay,
    ImageUploader,
  },
  data() {
    return {
      loading: false,
      form: {
        email: "",
        password: "",
        confirmPassword: "",
        sid: "",
        file1: "",
        file2: "",
      },
    };
  },
  methods: {
    async submit() {
      if (this.form.password !== this.form.confirmPassword) {
        message.error("The password and confirmation password do not match");
        return;
      }
      if (!this.form.file1 || !this.form.file2) {
        message.error("Please upload passport front and back");
        return;
      }

      this.loading = true;
      try {
        const formData1 = new FormData();
        formData1.append("file", this.form.file1);
        const formData2 = new FormData();
        formData2.append("file", this.form.file2);
        const [file1, file2] = await Promise.all([
          uploadImg(formData1),
          uploadImg(formData2),
        ]);
        if (
          file1.code === 0 &&
          file1.save_path &&
          file2.code === 0 &&
          file2.save_path
        ) {
          const params = {
            email: this.form.email,
            pwd: this.form.password,
            sid: this.form.sid,
            img1: file1.save_path,
            img2: file2.save_path,
          };
          const res = await signup(params);
          this.loading = false;
          if (res.code === 0) {
            message.success("Signup successfully");
            this.$router.push("/login");
          }
        }
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .image-uploader {
    height: 192px;
    .upload-area {
      height: 100%;
    }
    .preview-area {
      height: 100%;
    }
    .remove-btn {
      padding: 0;
      font-weight: 400;
      margin-top: 0;
    }
  }
}
</style>
